
export class StringHelper {

  public static replaceAt(string, index, replace) {
    return string.substring(0, index) + replace + string.substring(index + 1);
  }

  // se 1 carattere lo lascia così, altrimenti censura metà
  public static censorString(input: string | any): string {
    input = String(input);
  
    // List of full words/phrases to NOT censor (case-insensitive)
    const uncensoredWords = [
      "unknown", "Uknown", "Unknown", "Inconnu", "Niet bekend", "Unbekannt", "Sconosciuto", "Desconocido"
    ].map(w => w.toLowerCase());
  
    // Split input into words and non-words (e.g., spaces, punctuation)
    const regex = /\w+|\W+/g;
    const tokens = input.match(regex) || [];
  
    const censored = tokens.map(token => {
      // If it's a word, decide whether to censor or not
      if (/^\w+$/.test(token)) {
        if (uncensoredWords.includes(token.toLowerCase())) {
          return token;
        } else {
          const visibleChars = Math.floor(token.length / 2);
          const censoredChars = token.length - visibleChars;
          return token.slice(0, visibleChars) + '*'.repeat(censoredChars);
        }
      } else {
        // Return punctuation/whitespace as-is
        return token;
      }
    });
  
    return censored.join('');
  }
  

  // censura gli ultimi 3 caratteri della parola a prescindere dalla lunghezza
  // public static  censorString(input: string): string {
  //   input = String(input);

  //   // Split the input string by spaces, dots, and @ symbols
  //   const separators = [' ', '.', '@'];
    
  //   // Regular expression to match the parts (words) we need to censor
  //   const regex = /[^. @]+[. @]?/g;
  
  //   // Function to censor a single word
  //   const censorWord = (word: string): string => {
  //     if (word.length < 3) {
  //       return '*'.repeat(word.length); // Handle words shorter than 3 characters
  //     }
  //     return word.slice(0, word.length - 3) + '***'; // Replace last 3 characters with ***
  //   };
  
  //   // Split input string into components by regex
  //   const parts = input.match(regex) || [];
  
  //   // Process each component and censor accordingly
  //   const censoredParts = parts.map(part => {
  //     const separatorsFound = part.split(/([. @])/);
  //     const censoredSubParts = separatorsFound.map(subPart => {
  //       if (subPart && ![' ', '.', '@'].includes(subPart)) {
  //         return censorWord(subPart); // Censor word parts
  //       }
  //       return subPart; // Keep separators as is
  //     });
      
  //     return censoredSubParts.join('');
  //   });
  
  //   // Join the censored parts back together
  //   return censoredParts.join('');
  // }
}
  